






























import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  name: 'Login',

  methods: {
    async login () {
      try {
        await this.$login()
        await this.logInServer()
        this.$log('user_login', localStorage.getItem('gapi.full_name'), null, 'data_portal')
        this.$router.push('/')
      } catch (err) {
        this.$auth.setId(null)
        this.$auth.logout()
        return this.onGoogleOAuthError(err.error || err.message)
      }
    },

    logInServer () {
      return axios({
        method: 'post',
        url: process.env.VUE_APP_API_URI + '/auth/login',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          token: localStorage.getItem('gapi.id_token')
        }
      }).catch(() => {
        throw new Error('Could not verify credentials') // is there a better way?
      })
    },

    /**
       * Displays a pop up to show login error
       *
       * @param {String} error represents error message to display.
       */
    async onGoogleOAuthError (error: Error) {
      this.$Message.error({
        content: `Error login via Google because ${error}. Please try again after this popup disappears`,
        duration: 5
      })
      const delay = (t: number) => new Promise(resolve => setTimeout(resolve, t))
      delay(4000).then(() => window.location.reload(true))
    }
  }
})
